import { Button } from './ui/button';
import { Input } from './ui/input';
import { Label } from './ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

const blankLesion = () => ({ system: '', description: '' });

function LesionFields({ label, lesion = {}, systems, disabled, onChange }) {
  return <div className="grid gap-3 rounded border p-3 md:grid-cols-2">
    <div className="md:col-span-2 font-medium">{label}</div>
    <div><Label>Sistema</Label><Select value={lesion.system || ''} onValueChange={(system) => onChange({ ...lesion, system })} disabled={disabled}>
      <SelectTrigger><SelectValue placeholder="Selecionar sistema" /></SelectTrigger>
      <SelectContent>{systems.map((system) => <SelectItem key={system} value={system}>{system}</SelectItem>)}</SelectContent>
    </Select></div>
    <div><Label>Descrição</Label><Input value={lesion.description || ''} onChange={(event) => onChange({ ...lesion, description: event.target.value })} disabled={disabled} /></div>
  </div>;
}

function LesionGroup({ value = {}, systems, disabled, onChange }) {
  const secondary = value.secondary_lesions || [];
  return <div className="space-y-3">
    <LesionFields label="Lesão principal" lesion={value.primary_lesion || {}} systems={systems} disabled={disabled} onChange={(primary_lesion) => onChange({ ...value, primary_lesion })} />
    <div className="font-medium">Lesões secundárias</div>
    {secondary.map((lesion, index) => <div key={index} className="space-y-1">
      <LesionFields label={`Lesão secundária ${index + 1}`} lesion={lesion} systems={systems} disabled={disabled} onChange={(next) => onChange({ ...value, secondary_lesions: secondary.map((item, position) => position === index ? next : item) })} />
      {!disabled && <Button type="button" variant="ghost" onClick={() => onChange({ ...value, secondary_lesions: secondary.filter((_, position) => position !== index) })}>Remover lesão</Button>}
    </div>)}
    {!disabled && <Button type="button" variant="outline" onClick={() => onChange({ ...value, secondary_lesions: [...secondary, blankLesion()] })}>+ Adicionar lesão secundária</Button>}
  </div>;
}

export default function NecropsyDiagnosisFields({ value = {}, systems = [], causes = [], indeterminateCauses = [], final = false, disabled = false, onChange }) {
  const diagnosis = value || {};
  const contributory = diagnosis.contributory_diagnosis || { enabled: false, secondary_lesions: [] };
  return <div className="space-y-3 rounded-lg border p-4">
    <div><Label>Causa</Label><Select value={diagnosis.cause || ''} onValueChange={(cause) => onChange({ ...diagnosis, cause, indeterminate_cause: null, primary_lesion: null, secondary_lesions: [], contributory_diagnosis: null })} disabled={disabled}>
      <SelectTrigger><SelectValue placeholder="Selecionar causa" /></SelectTrigger>
      <SelectContent>{causes.map((cause) => <SelectItem key={cause} value={cause}>{cause}</SelectItem>)}</SelectContent>
    </Select></div>
    {diagnosis.cause === 'Indeterminada' && <div><Label>Motivo / Causa da indeterminação</Label><Select value={diagnosis.indeterminate_cause || ''} onValueChange={(indeterminate_cause) => onChange({ ...diagnosis, indeterminate_cause })} disabled={disabled}>
      <SelectTrigger><SelectValue placeholder="Selecionar motivo" /></SelectTrigger>
      <SelectContent>{indeterminateCauses.map((reason) => <SelectItem key={reason} value={reason}>{reason}</SelectItem>)}</SelectContent>
    </Select></div>}
    {diagnosis.cause && diagnosis.cause !== 'Indeterminada' && <>
      <LesionGroup value={diagnosis} systems={systems} disabled={disabled} onChange={onChange} />
      {final && <div className="space-y-3 border-t pt-3">
        <label className="flex items-center gap-2"><input type="checkbox" checked={Boolean(contributory.enabled)} disabled={disabled} onChange={(event) => onChange({ ...diagnosis, contributory_diagnosis: { ...contributory, enabled: event.target.checked } })} />Existe diagnóstico contributivo</label>
        {contributory.enabled && <LesionGroup value={contributory} systems={systems} disabled={disabled} onChange={(next) => onChange({ ...diagnosis, contributory_diagnosis: next })} />}
      </div>}
    </>}
  </div>;
}
